module.exports = "/_next/static/images/PatternLightDesktop-34ee3947d0008ce27f73d4a073bef6f5.png";